import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceGql } from './DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceGql';

export const UpstreamDatasourcesFilteredByFieldWithoutPersonalSpaceQueryGql: DocumentNode = gql`
query UpstreamDatasourcesFilteredByFieldWithoutPersonalSpaceQuery($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      upstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpace
        }
      }
    }
  }
}
${DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceGql}
`;
